import React from 'react';
import cx from 'clsx';

import { IconNoResult } from '@/assets';

import style from '../css/shared/flex.module.css';

export default React.memo(
  (props: { notImg?: boolean; height?: number; text?: string; className?: string }) => {
    return (
      <div
        className={cx(style.flexColumn, props.className)}
        style={{ height: props.height || '', justifyContent: 'center' }}>
        {!props.notImg && <IconNoResult width="130" height="112" />}
        <div
          style={{
            color: 'var(--color-light-blue-title)',
            fontSize: 16,
            padding: '0 20px',
          }}>
          {props.text || 'No results'}
        </div>
      </div>
    );
  },
);
